import { getConfig } from 'utils/config';

import { educatiusBranding } from './educatius';
import { enrollerBranding } from './enroller';

const { appBrandTheme } = getConfig();

export const branding = appBrandTheme === 'educatius' ? educatiusBranding : enrollerBranding;
